import React, { useEffect, useState } from "react";
import { Button, Table, Form, FloatingLabel, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Loading, AppPagination } from "../../components/Index.js";
import AddPHC from "./AddPHC.js";
import EditPHC from "./EditPHC.js";
import { PHCServices } from "../../../services/Phcs.js";
import AppNav from "../../../header/AppNav";
import { TalukServices } from "../../../services/Taluk.js";
import ConfirmModal from "../../../components/ConfirmModal";
import AlertModal from "../../../components/AlertModal";

function PHCs() {
  const [addModalShow, setAddModalShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [curPage, setCurPage] = useState(1); 
  const pageSize = 10;

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [confirmModalData, setConfirmModalData] = useState({
    title: "",
    message: "",
    onConfirm: null,
  });
  const [alertModalData, setAlertModalData] = useState({
    title: "",
    message: "",
    type: "info",
  });

  const [phc, setPhc] = useState([]);
  const [taluks, setTaluks] = useState([]);
  const [selectedTalukId, setSelectedTalukId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const getTaluksAndPhcs = async () => {
      try {
        const talukRes = await TalukServices.getAllTaluks();
        setTaluks(Array.isArray(talukRes) ? talukRes : []);

        const phcRes = await PHCServices.getAllPhcs();
        setPhc(Array.isArray(phcRes) ? phcRes : []);
      } catch (error) {
        console.error("Error fetching taluks or phcs:", error);
        setTaluks([]);
        setPhc([]);
      }
    };
    getTaluksAndPhcs();
  }, []);

  const getPhc = async () => {
    try {
      const res = await PHCServices.getAllPhcs();
      setPhc(Array.isArray(res) ? res : []);
    } catch (error) {
      console.error("Failed to fetch PHCs", error);
      setPhc([]);
    }
  };

  const handleDeleteClick = (phcId, phcName) => {
    setConfirmModalData({
      title: "Confirm Delete",
      message: `Are you sure you want to delete "${phcName}"?`,
      onConfirm: () => confirmDeletePhc(phcId),
    });
    setShowConfirmModal(true);
  };

  const confirmDeletePhc = async (id) => {
    setShowConfirmModal(false);
    setLoading(true);
    try {
      const res = await PHCServices.deletePhc(id);
      if (res.status === 200) {
        setAlertModalData({
          title: "Success",
          message: res.message || "PHC deleted successfully!",
          type: "success",
        });
        setShowAlertModal(true);
        getPhc();
      } else {
        setAlertModalData({
          title: "Error",
          message: "Error while deleting PHC",
          type: "error",
        });
        setShowAlertModal(true);
      }
    } catch (error) {
      setAlertModalData({
        title: "Error",
        message: error.message || "Failed to delete PHC",
        type: "error",
      });
      setShowAlertModal(true);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Filter PHCs
  const filteredPhcs = phc
    .filter((item) =>
      selectedTalukId ? item.talukId === parseInt(selectedTalukId) : true
    )
    .filter((item) => {
      const phcLower = item.phc?.toLowerCase() || "";
      const talukName = taluks.find((t) => t.id === item.talukId)?.taluk || "";
      const talukLower = talukName.toLowerCase();
      const searchTermLower = searchTerm.toLowerCase();

      return (
        phcLower.includes(searchTermLower) ||
        talukLower.includes(searchTermLower)
      );
    });


  const maxPage = Math.ceil(filteredPhcs.length / pageSize) || 1;

  useEffect(() => {
    setCurPage(1);
  }, [searchTerm, selectedTalukId]);

  const paginatedPhcs = filteredPhcs.slice(
    (curPage - 1) * pageSize,
    curPage * pageSize
  );

  return (
    <div>
      <AppNav />
      <h1 className="list-style">PHCs</h1><br/>
      <div className="list-table-style">
        <div className="add-button">
  <Row className="align-items-end g-2">
    <Col md={4}>
      <FloatingLabel controlId="Taluk" label="Taluk">
        <Form.Select
          value={selectedTalukId}
          onChange={(e) => setSelectedTalukId(e.target.value)}
          style={{ height: "calc(3.5rem + 2px)" }} // ✅ match input height
        >
          <option value="">All Taluks</option>
          {taluks.map((i) => (
            <option key={i.id} value={i.id}>
              {i.taluk}
            </option>
          ))}
        </Form.Select>
      </FloatingLabel>
    </Col>
    <Col Col md={{ span: 4, offset: 1 }}>
      <FloatingLabel controlId="search" label="Search by PHC or Taluk">
        <Form.Control
          type="text"
          placeholder="Search by PHC or Taluk"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </FloatingLabel>
    </Col>
    <Col md={3} className="d-flex justify-content-end">
      <Button
        onClick={() => setAddModalShow(true)}
        style={{ height: "calc(3.5rem + 2px)" }} // ✅ same height as inputs
      >
        Add PHC
      </Button>
      <AddPHC
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        onClose={() => getPhc()}
      />
    </Col>
  </Row>
</div>
        <Table striped bordered hover className="professional-table">
          <thead>
            <tr>
              <th>Sl no</th>
              <th className="list-item-align-center">PHC</th>
              <th className="list-item-align-center">Taluk</th>
              <th className="list-item-align-center">Edit</th>
              {/* <th className="list-item-align-center">Delete</th> */}
            </tr>
          </thead>
          <tbody>
            {!loading &&
              paginatedPhcs.map((i, index) => (
                <tr key={i.id}>
                  <td>{(curPage - 1) * pageSize + index + 1}</td>
                  <td className="list-item-align-center">{i.phc}</td>
                  <td className="list-item-align-center">
                    {taluks.find((t) => t.id === i.talukId)?.taluk || "N/A"}
                  </td>
                  <td className="list-item-align-center">
                    <EditPHC phc={i} onClose={() => getPhc()} />
                  </td>
                  {/* <td className="list-item-align-center">
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={() => handleDeleteClick(i.id, i.phc)}
                      size="lg"
                      className="action-icon delete-icon"
                      title="Delete PHC"
                    />
                  </td> */}
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      {filteredPhcs.length < 1 && !loading && (
        <h3 style={{ color: "#e77225", textAlign: "center" }}>List is empty</h3>
      )}
      {loading && <Loading />}

      <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={curPage}
          maxPage={maxPage}
          changePage={setCurPage}
        />
      </div>

      {/* Confirm Modal */}
      <ConfirmModal
        show={showConfirmModal}
        title={confirmModalData.title}
        message={confirmModalData.message}
        onConfirm={confirmModalData.onConfirm}
        onHide={() => setShowConfirmModal(false)}
      />

      {/* Alert Modal */}
      <AlertModal
        show={showAlertModal}
        title={alertModalData.title}
        message={alertModalData.message}
        type={alertModalData.type}
        onHide={() => setShowAlertModal(false)} 
      />
    </div>
  );
}

export default PHCs;
